// test1553
(1553 && 0);
